import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
// La barra de compra móvil se importa de forma directa (no lazy) para que esté
// disponible desde el primer scroll también en la versión publicada.
import { StickyBuyBar } from './components/StickyBuyBar';

/**
 * Everything below the first viewport is code-split so the Hero (LCP) ships
 * with the smallest possible JS payload. Each block reserves vertical space
 * while its chunk loads, which keeps CLS at zero.
 *
 * Recorrido: hero → dolor → solución → beneficios → los 100 scripts →
 * cómo funciona → para quién es → oferta → FAQ → cierre.
 */
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ScriptsSection = lazy(() => import('./components/ScriptsSection').then(m => ({
  default: m.ScriptsSection
})));
const HowItWorksSection = lazy(() => import('./components/HowItWorksSection').then(m => ({
  default: m.HowItWorksSection
})));
const AudienceSection = lazy(() => import('./components/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-mist'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="35yq6nee9s31" />} data-id="element-0" data-mp="36hwt7ylgu1r">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-mist text-ink" data-id="element-2" data-mp="3ucj91juaptoz">
      <Hero data-id="element-3" data-mp="d57fh2ybeij2" />
      <Deferred minHeight="620px" background="bg-white" data-id="element-4" data-mp="d3mkxdc02zl7">
        <PainSection data-id="element-5" data-mp="85l3sxy4xacd" />
      </Deferred>
      <Deferred minHeight="700px" background="bg-ink" data-id="element-6" data-mp="86mfn4mz60v5">
        <SolutionSection data-id="element-7" data-mp="83qdt580as1f" />
      </Deferred>
      <Deferred minHeight="640px" data-id="element-8" data-mp="3gmfwxlp4rgd9">
        <BenefitsSection data-id="element-9" data-mp="3glo2wfb6lqp3" />
      </Deferred>
      <Deferred minHeight="1100px" background="bg-ink" data-id="element-10" data-mp="3bmtij8xkfu2v">
        <ScriptsSection data-id="element-11" data-mp="3bk702e94zu5v" />
      </Deferred>
      <Deferred minHeight="380px" data-id="element-12" data-mp="3qbppt3rst32f">
        <HowItWorksSection data-id="element-13" data-mp="3qcqzp4x2vjik" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-white" data-id="element-14" data-mp="3lkhfm5in9do7">
        <AudienceSection data-id="element-15" data-mp="3liwlui45lyre" />
      </Deferred>
      <Deferred minHeight="900px" background="bg-ink" data-id="element-16" data-mp="2xun2rnybrp3y">
        <OfferSection data-id="element-17" data-mp="2xtbzrqcpeldw" />
      </Deferred>
      <Deferred minHeight="640px" background="bg-white" data-id="element-18" data-mp="2svtqtzyos65w">
        <FaqSection data-id="element-19" data-mp="2svaf50zmqe0b" />
      </Deferred>
      <Deferred minHeight="560px" background="bg-ink" data-id="element-20" data-mp="18drjrx1hphec">
        <FinalCta data-id="element-21" data-mp="18c6p87f6dygh" />
      </Deferred>
      <Deferred minHeight="300px" background="bg-ink" data-id="element-22" data-mp="1d4hnl5u9pc6x">
        <Footer data-id="element-23" data-mp="1d59jyivovdy9" />
      </Deferred>
      <StickyBuyBar data-id="element-24" data-mp="1d6awysw9maim" />
    </main>;
}